import { render, staticRenderFns } from "./TreatmentSession.vue?vue&type=template&id=37603410"
import script from "./TreatmentSession.vue?vue&type=script&lang=js"
export * from "./TreatmentSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports